import { configureStore } from '@reduxjs/toolkit'
import { storefrontApi } from '../Api/Api'
import { authSlice } from './AuthSlice'
import TokenMiddleware from '../Api/TokenMiddleware'
import { cartSlice } from "./CartSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    cart: cartSlice.reducer,
    [storefrontApi.reducerPath]: storefrontApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
        .concat(storefrontApi.middleware)
        .concat(TokenMiddleware),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch